import { EndorsementKey, type EndorsementConfig } from '../../types';
import {
  selectAkHash,
  selectAlcoholicBeverageSales,
  selectCheckedEndorsements,
  selectGrossAnnualSales,
} from '../../../../selectors/application';
import { liquorClasses100 } from '../../../../constants';

export const config: EndorsementConfig = {
  endorsementKey: EndorsementKey.LiquorLiabilityEndorsement,
  label: 'Liquor Liability Coverage',
  description: 'Add this coverage if you sell, serve or furnish alcoholic beverages.',
  recommended: false,
};

export const validateLiquorSalesInput = (inputValue?: number, grossAnnualSales?: number) =>
  Boolean(inputValue && grossAnnualSales && inputValue < grossAnnualSales / 2);

export const isLiquorLiabilityValid = (state: ReduxState) => {
  const akHash = selectAkHash(state);
  const isLiquorException = liquorClasses100.includes(akHash || '');
  const isChecked = selectCheckedEndorsements(state).includes(EndorsementKey.LiquorLiabilityEndorsement);
  if (!isChecked) return true;

  const alcoholicBeverageSales = selectAlcoholicBeverageSales(state);
  if (isLiquorException && alcoholicBeverageSales) return true;
  const grossAnnualSales = selectGrossAnnualSales(state) || Infinity;
  return validateLiquorSalesInput(alcoholicBeverageSales, grossAnnualSales);
};
